import { reactive } from 'vue'

export const store = reactive({
    is_debug: process.env.NODE_ENV == "development" ? true : false,
    api_url: process.env.NODE_ENV == "development" ? 'http://localhost/galita-api/api' : 'https://api.getcoupon.co.il',
    api_key: '',
    id: 0,
    company_key: '',
    companies: {
        api1: {
            key: 'tmura',
            key2: 'iec',
            name: 'חברת החשמל',
            image: 'hash.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api2: {
            key: 'tmura',
            key2: 'bezeq',
            name: 'בזק',
            image: 'bezeq.png',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api3 : {
            key: 'megalean',
            key2: 'megalean',
            name: 'מגה לאן',
            image: 'megalean.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api19 : {
            key: 'dts',
            key2: 'goodies',
            name: 'גודיז',
            image: 'goodies.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api22 : {
            key: 'megalean',
            key2: 'hvr',
            name: 'חבר',
            image: 'hvr.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api8 : {
            key: 'tmura',
            key2: 'meshek',
            name: 'משקארד',
            image: 'meshek.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api6 : {
            key: 'dts',
            key2: 'goldnorth',
            name: 'גולד הצפון',
            image: 'goldnorth.png',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api4 : {
            key: 'megalean',
            key2: 'clalit',
            name: 'כללית',
            image: 'clalit.png',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api5 : {
            key: 'megalean',
            key2: 'irgun_morim',
            name: 'ארגון המורים',
            image: 'irgun_morim.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api7 : {
            key: 'multipass',
            key2: 'pais',
            name: 'מפעל הפיס',
            image: 'pais.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api9 : {
            key: 'multipass',
            key2: 'yours',
            name: 'מועדון שלך',
            image: 'yours.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api10 : {
            key: 'multipass',
            key2: 'shlaykes',
            name: 'שלישי בשלייקס',
            image: 'shlaykes.webp',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api11 : {
            key: 'tmura',
            key2: 'itu',
            name: 'הסתדרות המורים',
            image: 'itu.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api12 : {
            key: 'multipass',
            key2: 'tov',
            name: 'מועדון טוב',
            image: 'tov.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api13 : {
            key: 'multipass',
            key2: 'cal',
            name: 'ויזה כאל',
            image: 'cal.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api14 : {
            key: 'dts', 
            key2: 'max',
            name: 'max',
            image: 'max.png',
            text1: 'יש להכניס מספר כרטיס אשראי ללא רווחים ומקפים',
        },
        api15 : {
            key: 'dts', 
            key2: 'hist',
            name: 'ביחד בשבילך',
            image: 'hist.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api16 : {
            key: 'dts', 
            key2: 'beazdaa',
            name: 'בהצדעה',
            image: 'beazdaa.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api18 : {
            key: 'dts',
            key2: 'nofshonit',
            name: 'נופשונית',
            image: 'nofshonit.jpg',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api20 : {
            key: 'dts',
            key2: 'htz',
            name: 'הייטק זון',
            image: 'htz.png',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api21 : {
            key: 'dts',
            key2: 'shave',
            name: 'מועדון שווה',
            image: 'shave.png',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
        api23 : {
            key: 'multipass',
            key2: 'bonus_leumi',
            name: 'לאומי בונוס',
            image: 'bonus_leumi.png',
            text1: 'יש להכניס קוד קופון או מספר שובר',
        },
    },
});